import axios from 'axios'
import { Message } from 'element-ui'
import Cookies from 'js-cookie'
import { API_CONFIG, RESPONSE_CODE } from './config'

// 创建axios实例
const service = axios.create({
  baseURL: API_CONFIG.BASE_URL, // api的base_url
  timeout: API_CONFIG.TIMEOUT // 请求超时时间
})

// 调试日志
const debugLog = (message, data = null) => {
  if (API_CONFIG.DEBUG) {
    console.log(`[API Debug] ${message}`, data)
  }
}

// request拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    debugLog('发送请求', {
      url: config.url,
      method: config.method,
      params: config.params,
      data: config.data
    })

    const token = Cookies.get('admin_token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    debugLog('请求错误', error)
    return Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    debugLog('收到响应', {
      status: response.status,
      data: res
    })

    // 如果自定义代码不是200，则判断为错误
    if (res.code !== RESPONSE_CODE.SUCCESS) {
      const errorMessage = res.message || 'Error'

      Message({
        message: errorMessage,
        type: 'error',
        duration: 5 * 1000
      })

      // 401: 未授权 或 403: 禁止访问 - 自动跳转到登录页
      if (res.code === RESPONSE_CODE.UNAUTHORIZED || res.code === RESPONSE_CODE.FORBIDDEN) {
        handleAuthError('认证失败，请重新登录')
      }

      return Promise.reject(new Error(errorMessage))
    } else {
      return res
    }
  },
  error => {
    debugLog('响应错误', error)

    // 处理HTTP状态码错误
    if (error.response) {
      const status = error.response.status
      let errorMessage = error.message

      // 401未授权或403禁止访问 - 自动跳转到登录页
      if (status === 401 || status === 403) {
        errorMessage = status === 401 ? '登录已过期，请重新登录' : '没有访问权限，请重新登录'
        handleAuthError(errorMessage)
      } else {
        Message({
          message: getErrorMessage(status, errorMessage),
          type: 'error',
          duration: 5 * 1000
        })
      }
    } else {
      Message({
        message: error.message || '网络错误，请检查网络连接',
        type: 'error',
        duration: 5 * 1000
      })
    }

    return Promise.reject(error)
  }
)

// 处理认证错误
const handleAuthError = (message = '认证失败，请重新登录') => {
  debugLog('认证错误', message)

  // 清除token并跳转到登录页
  Cookies.remove('admin_token')
  Cookies.remove('admin_user')

  Message({
    message,
    type: 'error',
    duration: 3 * 1000
  })

  // 延迟跳转，让用户看到错误信息
  setTimeout(() => {
    window.location.href = '/login'
  }, 1000)
}

// 获取错误信息
const getErrorMessage = (status, defaultMessage) => {
  const errorMessages = {
    400: '请求参数错误',
    404: '请求的资源不存在',
    500: '服务器内部错误',
    502: '网关错误',
    503: '服务不可用',
    504: '网关超时'
  }

  return errorMessages[status] || defaultMessage || '未知错误'
}

export default service
